import { useEffect, useState } from 'react';
import { Grid, TextField, InputLabel, FormControl, Button, InputAdornment } from '@mui/material';
import SignInCarosel from './signInCarousel'
import './employerStyle.scss'
import { useNavigate } from "react-router-dom";
import { Spin } from 'antd';
import { VALIDATION_MSG, useValidation } from '../../constant';
import { ReactComponent as LoginBg } from '../../assets/images/sign-in-bg.svg';
import { ReactComponent as LoginBack } from '../../assets/images/left-nav.svg';
import { EmailPhoneValidate } from '../../sevices/account';


// SIGNUP FUNCTION 

const SignUP = () => {

    const queryParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);
    const rolesEmployee = queryParams.get('roles');
    const [locationValue, setLocationValue] = useState('');
    const emailErr = '';
    const [verify, setVerify] = useState(false);
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    const {
        email,
        setEmail,
        emailError,
        handleEmailBlur,
        setPhone,
        phoneError,
        phone,
        setEmailError,
        handlePhoneBlur,
        setPhoneError
    } = useValidation();


    // REDIRECT TO LOGIN PAGE ROLE WISE
    const login = () => {
        if (rolesEmployee === 'employee') {
            navigate("/login?roles=employee")
        } else {
            navigate("/login?roles=employer")
        }

    }
    //  ROLE WISE REDIRECT THE PAGE
    const signup = async (event) => {
        event?.preventDefault()

        if (!email) {
            setEmailError(VALIDATION_MSG.emailRequired);
        }
        if (!phone) {
            setPhoneError(VALIDATION_MSG.phoneRequired);
        }

        if (rolesEmployee === 'employee') {
            if (email && phone?.length >= 10 && !emailError && !emailErr) {
                setLoading(true);
                const data = {
                    email,
                    phone
                }
                setTimeout(() => {
                    navigate("/employeesignin", { state: data })
                }, 1000);
            }
        } else {

            if (email && phone?.length >= 10 && !emailError && !emailErr) {
                setLoading(true);
                const data = {
                    email,
                    phone
                }
                try {
                    const response = await EmailPhoneValidate(data)
                    if (response?.status === 200) {
                        setLoading(false)
                        if (!response?.data?.account_exist) {
                            navigate("/company-registration", { state: data })
                        } else {
                            setVerify(response?.data?.account_exist)
                        }
                    }
                } catch (error) {
                    console.log('error', error);

                }

            }
        }
    }

    // SET EMAIL VALUE FUNCTION 
    const handleEmailChange = (event) => {
        if (verify) {
        setVerify(false)
        }
        setEmail(event.target.value);
    }

    useEffect(() => {
        const locationIp = async () => {
            try {
                const response = await fetch('https://ipapi.co/json/');
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setLocationValue(data?.city);
            } catch (error) {
                console.log('location_error', error);
            }
        };

        locationIp();
    }, []);


    return (
        <div className="SinginFormPage">
            {loading && (
                <div className="SiginLoader">
                    <Spin spinning />
                </div>
            )}

            <Grid container spacing={0}>
                {rolesEmployee === 'employer' ? <Grid item xs={12} sm={6}>
                    <div className="SinginFormLeft">
                        <Button className='loginBackBtn' onClick={handleGoBack}>
                            <LoginBack />
                            <span>Back</span>
                        </Button>
                        <LoginBg className="SinginFormBgImg BannerSVG" />
                        <div className="SinginFormCarouselContainer">
                            <div className="SinginFormCarouselTitle">
                                Join over 15,000+ <br />
                                Part Timers around {locationValue}
                            </div>
                            <SignInCarosel />
                        </div>
                    </div>
                </Grid> : <Grid item xs={12} sm={6}>
                    <div className="SinginFormLeft">
                        <Button className='loginBackBtn' onClick={handleGoBack}>
                            <LoginBack />
                            <span>Back</span>
                        </Button>
                        <img src={require('../../assets/images/jobseek.jpg')} className="SinginFormBgImg" style={{ padding: '50px 120px' }} alt="" />
                        <div className="SinginFormCarouselContainer" style={{ top: 0, paddingBottom: '30px' }}>
                            <div className="SinginFormCarouselTitle">
                                Join over 15,000+ <br />
                                Part Timers around {locationValue}
                            </div>
                            <SignInCarosel />
                        </div>
                    </div>
                </Grid>}

                <Grid item xs={12} sm={5}>
                    <div className="SinginFormRight">
                        <a onClick={handleGoBack} >
                            <img src={require('../../assets/images/Logo Blue TM.png')} className="SinginFormLogo" alt="" />
                        </a>
                        <div className="SinginFormTitleContainer">
                            <span className="SinginFormTitle">
                                {rolesEmployee === 'employee' ? 'Part-Time Power, in Your Pocket!' : 'Employer Sign Up'}
                            </span>
                            <span>{rolesEmployee === 'employee' ? 'Sign up now and start earning on your terms.' : "Unlock Your Next Hire – Sign Up as an Employer"}</span>
                        </div>
                        <div className="SinginFormPageContainer">
                            <form>
                                <FormControl className="form-control">
                                    <InputLabel htmlFor="name-input">Email id</InputLabel>
                                    <TextField
                                        id="name-input"
                                        variant="outlined"
                                        value={email}
                                        onBlur={handleEmailBlur}
                                        error={!!emailError || !!emailErr}
                                        helperText={emailError || emailErr}

                                        onChange={(event) => handleEmailChange(event)}
                                        InputProps={{
                                            type: 'email',
                                        }}
                                        inputProps={{
                                            maxLength: 50
                                        }}
                                    />
                                </FormControl>
                                <FormControl className="form-control">
                                    <InputLabel htmlFor="name-input">Mobile number</InputLabel>
                                    <TextField
                                        id="name-input"
                                        variant="outlined"
                                        onBlur={handlePhoneBlur}
                                        error={Boolean(phoneError)}
                                        helperText={phoneError}
                                        value={phone}
                                        onChange={(event) => {
                                            const phoneNumber = event.target.value;
                                            if (verify) {
                                                setVerify(false)
                                                }
                                            if (phoneNumber.length <= 10) {
                                                const numericInput = phoneNumber.replace(/\D/g, '')
                                                setPhone(numericInput);
                                            }
                                        }}
                                        inputProps={{ inputMode: 'numeric' }}
                                        InputProps={
                                            {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        +91
                                                    </InputAdornment>
                                                )
                                            }
                                        }
                                    />
                                </FormControl>
                                {Boolean(verify) && (
                                    <p className='text-center' style={{ color: 'red', fontSize: '14px', textAlign: 'center' }}>
                                        Already Registered.  Please Log in.
                                    </p>
                                )}
                                <Button type='submit' onClick={signup} variant="contained" className="SinginFormBtn">Sign up</Button>
                                <Button type='button' onClick={login} variant="outlined" className="SinginFormLoginBtn">Already signed up? Sign in here</Button>
                            </form>
                        </div>
                    </div>
                </Grid>
            </Grid>
            <img src={require('../../assets/images/geo.png')} className="SignInGeoTop" alt="" />
            <img src={require('../../assets/images/geo1.png')} className="SignInGeoBottom" alt="" />
        </div>
    );
}

export default SignUP;